import { config } from 'api';
import { UNKNOWN_ERROR } from 'utils/errors';

const INIT_POST = `${config.apiBasePath}/slotsub/init-registration`;
const SLOTS_POST = `${config.apiBasePath}/slotsub/slots`;
const WALLET_POST = `${config.apiBasePath}/slotsub/wallet`;

export const OR_REQUEST_INIT_REGISTRATION_DATA = 'OR_REQUEST_INIT_REGISTRATION_DATA';
export const OR_RECEIVE_INIT_REGISTRATION_DATA = 'OR_RECEIVE_INIT_REGISTRATION_DATA';
export const OR_RECEIVE_INIT_REGISTRATION_DATA_ERROR = 'OR_RECEIVE_INIT_REGISTRATION_DATA_ERROR';
export const OR_CHOOSE_ADDRESS = 'OR_CHOOSE_ADDRESS';
export const OR_ENTER_PHONE = 'OR_ENTER_PHONE';
export const OR_TOGGLE_PHONE_NUMBER_VALIDATION_ERROR = 'OR_TOGGLE_PHONE_NUMBER_VALIDATION_ERROR';
export const OR_CHOOSE_FREQUENCY = 'OR_CHOOSE_FREQUENCY';
export const OR_SELECT_TIME_OF_DAY = 'OR_SELECT_TIME_OF_DAY';
export const OR_CHOOSE_SLOT = 'OR_CHOOSE_SLOT';
export const OR_SELECT_PAYMENT_METHOD = 'OR_SELECT_PAYMENT_METHOD';
export const OR_REQUEST_SLOTS = 'OR_REQUEST_SLOTS';
export const OR_RECEIVE_SLOTS = 'OR_RECEIVE_SLOTS';
export const OR_RECEIVE_SLOTS_ERROR = 'OR_RECEIVE_SLOTS_ERROR';
export const OR_CLOSE_CONFLICTING_ORDERS_MODAL = 'OR_CLOSE_CONFLICTING_ORDERS_MODAL';
export const OR_REQUEST_WALLET = 'OR_REQUEST_WALLET';
export const OR_RECEIVE_WALLET = 'OR_RECEIVE_WALLET';
export const OR_RECEIVE_WALLET_ERROR = 'OR_RECEIVE_WALLET_ERROR';
export const OR_TOGGLE_CANCEL_REGISTRATION_MODAL = 'OR_TOGGLE_CANCEL_REGISTRATION_MODAL';
export const OR_REGISTRATION_RESET_DATA = 'OR_REGISTRATION_RESET_DATA';

export function requestInitRegistrationData() {
  return {
    type: OR_REQUEST_INIT_REGISTRATION_DATA,
  };
}

export function receiveInitRegistrationData(data) {
  return {
    type: OR_RECEIVE_INIT_REGISTRATION_DATA,
    data,
  };
}

export function receiveInitRegistrationDataError({ error }) {
  return {
    type: OR_RECEIVE_INIT_REGISTRATION_DATA_ERROR,
    error,
  };
}
export function initRegistration() {
  return (dispatch, getState, { network }) => {
    dispatch(requestInitRegistrationData());
    return network.post(INIT_POST)
      .then((data) => {
        dispatch(receiveInitRegistrationData(data));
      })
      .catch(err => {
        dispatch(receiveInitRegistrationDataError(err.data || UNKNOWN_ERROR));
      });
  };
}

export function chooseAddress(addressId, hasChanged) {
  return {
    type: OR_CHOOSE_ADDRESS,
    addressId,
    hasChanged,
  };
}

export function enterPhone(phoneNumber) {
  return {
    type: OR_ENTER_PHONE,
    phoneNumber,
  };
}

export function togglePhoneNumberValidationError(shouldShowPhoneNumberValidationError) {
  return {
    type: OR_TOGGLE_PHONE_NUMBER_VALIDATION_ERROR,
    shouldShowPhoneNumberValidationError,
  };
}

export function chooseFrequency(frequency, hasChanged) {
  return {
    type: OR_CHOOSE_FREQUENCY,
    frequency,
    hasChanged,
  };
}

export function requestSlots(weekday) {
  return {
    type: OR_REQUEST_SLOTS,
    weekday,
  };
}

export function receiveSlots(data, weekday) {
  return {
    type: OR_RECEIVE_SLOTS,
    data,
    weekday,
  };
}

export function receiveSlotsError({ error }) {
  return {
    type: OR_RECEIVE_SLOTS_ERROR,
    error,
  };
}

export function closeConflictingOrdersModal() {
  return {
    type: OR_CLOSE_CONFLICTING_ORDERS_MODAL,
  };
}

export function getSlots(params) {
  return (dispatch, getState, { network }) => {
    dispatch(requestSlots(params.day));
    return network.post(SLOTS_POST, {
      body: JSON.stringify(params),
    })
      .then((data) => {
        dispatch(receiveSlots(data, params.day));
      })
      .catch(err => {
        dispatch(receiveSlotsError(err.data || UNKNOWN_ERROR));
      });
  };
}

export function selectTimeOfDay(timeOfDay) {
  return {
    type: OR_SELECT_TIME_OF_DAY,
    timeOfDay,
  };
}

export function chooseSlot(slotId, hasChanged) {
  return {
    type: OR_CHOOSE_SLOT,
    slotId,
    hasChanged,
  };
}

export function requestWallet() {
  return {
    type: OR_REQUEST_WALLET,
  };
}

export function receiveWalletData(data) {
  return {
    type: OR_RECEIVE_WALLET,
    data,
  };
}
export function receiveWalletDataError({ error }) {
  return {
    type: OR_RECEIVE_WALLET_ERROR,
    error,
  };
}

export function getWallet(addressId) {
  return (dispatch, getState, { network }) => {
    dispatch(requestWallet());
    return network.post(WALLET_POST, {
      body: JSON.stringify({ addressId }),
    })
      .then((data) => {
        dispatch(receiveWalletData(data));
      })
      .catch(err => {
        dispatch(receiveWalletDataError(err.data || UNKNOWN_ERROR));
      });
  };
}

export function selectPaymentMethod(paymentMethod) {
  return {
    type: OR_SELECT_PAYMENT_METHOD,
    paymentMethod,
  };
}

export function toggleCancelRegistrationModal() {
  return {
    type: OR_TOGGLE_CANCEL_REGISTRATION_MODAL,
  };
}

export function resetRegistrationData() {
  return {
    type: OR_REGISTRATION_RESET_DATA,
  };
}
